import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getChecklistAfterGroupAvailableColumns, getRealEstatesShort } from './api';
import { getChecklistAfterSeasonListAllNotDeleted } from 'pages/PageChecklistAfterSeasonList/api';

export const path = '/checklist/after/group/list';

const PageChecklistAfterGroup: React.FC = (props) => {
  const ChecklistAfterGroup = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getChecklistAfterGroupAvailableColumns,
      realEstates: getRealEstatesShort,
      seasons: getChecklistAfterSeasonListAllNotDeleted,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ChecklistAfterGroup {...props} />;
};

export default PageChecklistAfterGroup;
